import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import the centralized config

const BarChartViz01 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey;
    };

    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key);
        if (filterCriteria[key].length === 0) {
          return true;
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    const filteredData = jsonData.filter(filterData);

    const demcat01Counts = filteredData.reduce((acc, item) => {
      const demcat01 = item.demographic_category_01;
      if (!acc[demcat01]) {
        acc[demcat01] = 0;
      }
      acc[demcat01]++;
      return acc;
    }, {});

    const demcat01Names = Object.keys(demcat01Counts).sort((a, b) =>
      a.localeCompare(b)
    );
    const chartData = demcat01Names.map((demcat01) => demcat01Counts[demcat01]);

    setCategories(demcat01Names);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25;
    const minBars = 10;
    const chartHeight = Math.max(
      barHeight * demcat01Names.length,
      barHeight * minBars
    );
    const optionsViz01 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight, // Match the parent container height
        width: "100%", // Match the parent container width
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          distributed: false,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 20,
        style: {
          colors: ["#000"],
        },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 2.5,
          color: "#fff",
          opacity: 1,
        },
      },
      xaxis: {
        categories: demcat01Names,
      },
    };

    const viz01 = new ApexCharts(
      document.querySelector("#viz-01"),
      optionsViz01
    );
    viz01.render();

    return () => {
      viz01.destroy();
    };
  }, [filterCriteria]);

  return (
    <div
      id="viz-01"
      style={{ width: "100%", height: "100%" }} // Ensure the container takes up full width and height
    ></div>
  );
};

export default BarChartViz01;
